import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT, FONTS } from "../../constants/Styles";

export const SUMMARY_WIDTH_PIXELS = 96;
export const SUMMARY_HEIGHT_PIXELS = 48;

export const FootprintSummaryContainer = styled.div<{
  canOpenInspector: boolean;
}>`
  cursor: ${({ canOpenInspector }) => (canOpenInspector ? "pointer" : "auto")};
  width: ${SUMMARY_WIDTH_PIXELS}px;
  height: ${SUMMARY_HEIGHT_PIXELS}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoFootprintData = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight200};
`;

export const Title = styled.div`
  font-size: ${FONT_SIZE.size24};
  font-family: ${FONTS.spaceGrotesk};
`;

export const InspectorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1rem;
`;

export const FootprintDetails = styled.div`
  width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
